﻿export async function DiagramSelectNav() {
    $('.js-select-nav').on('change', function () {
        var $option = $(this).find('option:selected')
            , newUrl = $(this).val()
            ;

        if ($option.data('target') === "_blank") {
            window.open(newUrl);
        } else {
            switch (newUrl) {
                // relative
                case (newUrl.substr(0, 1) === "/"):
                    window.location.pathname = newUrl;
                    break;
                // anchor
                case (newUrl.substr(0, 1) === "#"):
                    window.location.hash = newUrl;
                    break;
                // none of the above, assume absolute path
                default:
                    window.location = newUrl;
                    break;
            }
        }
    });
}